module.exports = __webpack_public_path__ + "img/about_cont_erm_z.30505bdd.png";